import { RemarquesService } from '../services/RemarquesService'

export const state = {
  remarques: [],
  loader: false,
}
export const mutations = {
  setRemarques(currentState, remarques) {
    currentState.remarques.remarques = remarques
  },
  setRemarquesLoading(currentState, bool) {
    currentState.remarques.loader = bool
  },
}
export const actions = {
  loadAllRemarques({ commit }, clientId) {
    commit('setRemarquesLoading', true)
    RemarquesService.getAllRemarques(clientId)
      .then(remarques => {
        commit('setRemarquesLoading', false)
        commit('setRemarques', remarques)
      })
  },
}
export default { state, actions, mutations }
